import { render, staticRenderFns } from "./HomeMetrics.vue?vue&type=template&id=b1ab2c04"
import script from "./HomeMetrics.vue?vue&type=script&lang=js"
export * from "./HomeMetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports